import React, { Component } from 'react';
import { getToken } from 'utils/auth';
import './GameFinderWindow.css';

class GameFinderWindow extends Component {
  render() {
    const token = getToken();
    const tokenParam = token ? `token=${token}` : '';

    return (
      <div className="game-finder-window">
        <iframe
          title="Game Finder"
          src={`${process.env.REACT_APP_GAMEFINDER_URI}?${tokenParam}`}
          height="100%"
          width="100%"
          frameBorder="0"
        />
      </div>
    );
  }
}

export default GameFinderWindow;
